<template>
    <div>
        <section class="section is-medium">
            <div class="container">
                <h1 class="titles-white is-capitalized is-size-1 is-size-4-mobile">ENTERATE DE LAS ULTIMAS NOTICIAS <br> SOBRE MISION AGAPE</h1>
            </div>
        </section>
        <section class="section bg-white">
            <div class="container">
                <p class="titles-secondary is-size-1 is-size-3-mobile has-text-left">Blog</p>
                <div class="columns is-multiline">
                    <div v-for="entry in entries" v-bind:key="entry.id" class="column is-4">
                        <BlogCard :id="entry.id" :title="entry.title" :body="entry.body" :tags="entry.categorie" :shorted="false" @selected="is_selected"></BlogCard>
                    </div>
                </div>
            </div>
        </section>
        <b-modal :active.sync="isModal_Blog_Active" has-modal-card :destroy-on-hide="false" aria-role="dialog" aria-modal scroll="clip">
            <BlogModal :id="selectedEntry.id" :title="selectedEntry.title" :body="selectedEntry.body"></BlogModal>
        </b-modal>
    </div>
</template>

<script>
import BlogCard from '@/components/BlogCard.vue'
import BlogModal from '@/components/BlogModal.vue'

export default {
    name: 'Blog',
    components: {
        BlogCard,
        BlogModal
    },
    data() {
        return {
            entries: [
                 {
                    "userId": 1,
                    "id": 1,
                    "categorie": [1],
                    "title": "sunt aut facere repellat provident occaecati excepturi optio reprehenderit",
                    "body": "quia et suscipit\nsuscipit recusandae consequuntur expedita et cum\nreprehenderit molestiae ut ut quas totam\nnostrum rerum est autem sunt rem eveniet architecto"
                },
                {
                    "userId": 1,
                    "id": 2,
                    "categorie": [2],
                    "title": "qui est esse",
                    "body": "est rerum tempore vitae\nsequi sint nihil reprehenderit dolor beatae ea dolores neque\nfugiat blanditiis voluptate porro vel nihil molestiae ut reiciendis\nqui aperiam non debitis possimus qui neque nisi nulla"
                },
                {
                    "userId": 1,
                    "id": 3,
                    "categorie": [3],
                    "title": "ea molestias quasi exercitationem repellat qui ipsa sit aut",
                    "body": "et iusto sed quo iure\nvoluptatem occaecati omnis eligendi aut ad\nvoluptatem doloribus vel accusantium quis pariatur\nmolestiae porro eius odio et labore et velit aut"
                },
                {
                    "userId": 1,
                    "id": 4,
                    "categorie": [2,3],
                    "title": "eum et est occaecati",
                    "body": "ullam et saepe reiciendis voluptatem adipisci\nsit amet autem assumenda provident rerum culpa\nquis hic commodi nesciunt rem tenetur doloremque ipsam iure\nquis sunt voluptatem rerum illo velit"
                },
                {
                    "userId": 1,
                    "id": 5,
                    "categorie": [1,3],
                    "title": "nesciunt quas odio",
                    "body": "repudiandae veniam quaerat sunt sed\nalias aut fugiat sit autem sed est\nvoluptatem omnis possimus esse voluptatibus quis\nest aut tenetur dolor neque"
                },
                {
                    "userId": 1,
                    "id": 6,
                    "categorie": [1,2],
                    "title": "dolorem eum magni eos aperiam quia",
                    "body": "Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo. Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt. Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit, sed quia non numquam eius modi tempora incidunt ut labore et dolore magnam aliquam quaerat voluptatem. Ut enim ad minima veniam, quis nostrum exercitationem ullam corporis suscipit laboriosam, nisi ut aliquid ex ea commodi consequatur? Quis autem vel eum iure reprehenderit qui in ea voluptate velit esse quam nihil molestiae consequatur, vel illum qui dolorem eum fugiat quo voluptas nulla pariatur? At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga. Et harum quidem rerum facilis est et expedita distinctio. Nam libero tempore, cum soluta nobis est eligendi optio cumque nihil impedit quo minus id quod maxime placeat facere possimus, omnis voluptas assumenda est, omnis dolor repellendus. Temporibus autem quibusdam et aut officiis debitis aut rerum necessitatibus saepe eveniet ut et voluptates repudiandae sint et molestiae non recusandae. Itaque earum rerum hic tenetur a sapiente delectus, ut aut reiciendis voluptatibus maiores alias consequatur aut perferendis doloribus asperiores repellat."
                },
            ],
            isModal_Blog_Active: false,
            selectedEntry: {}
        }
    },
    methods: {
        is_selected(dts) {
            this.selectedEntry = dts
            this.isModal_Blog_Active = true
        }
    }
}
</script>

<style>

</style>